import { inject } from '@angular/core';
import { NotificationProvider } from 'wflow-cdk';
import { WfNotificationService } from 'wflow-features/notifications';

export function notificationResolver(): NotificationProvider {
  const position = 'toast-bottom-right';
  const notificationsSvc = inject(WfNotificationService);

  return {
    timeout: 8000,
    update: (toastId, notification, options) =>
      notificationsSvc.update(
        toastId,
        {
          ...(notification.text != null ? { message: notification.text } : {}),
          ...(notification.title != null ? { title: notification.title } : {}),
        },
        options,
      ),
    dismiss: (toastId) => notificationsSvc.remove(toastId),
    notify: (type, notification, config) => {
      switch (type) {
        case 'success':
          return notificationsSvc.success(
            notification.text ?? '',
            notification.title ?? '',
            {
              ...config,
              positionClass: position,
              timeOut: 3000,
              disableTimeOut: notification.infinite,
              closeButton: notification.closable ?? true,
              onActivateTick: notification.sendFromOutsideAngularZone ?? false,
            },
          );
        case 'error':
          return notificationsSvc.error(
            notification.text ?? '',
            notification.title ?? '',
            {
              positionClass: position,
              timeOut: 7000,
              disableTimeOut: notification.infinite,
              closeButton: notification.closable ?? true,
              tapToDismiss: notification.tapToDismiss,
              progressBar: true,
              onActivateTick: notification.sendFromOutsideAngularZone ?? false,
              messageClass: notification.errorStatus,
              ...config,
            },
            notification.errorJson,
          );
        case 'warning':
          return notificationsSvc.warning(
            notification.text ?? '',
            notification.title ?? '',
            {
              positionClass: position,
              timeOut: 7000,
              disableTimeOut: notification.infinite,
              closeButton: notification.closable ?? true,
              progressBar: true,
              onActivateTick: notification.sendFromOutsideAngularZone ?? false,
              ...config,
            },
          );
        case 'info':
          return notificationsSvc.info(
            notification.text ?? '',
            notification.title ?? '',
            {
              positionClass: position,
              timeOut: 7000,
              disableTimeOut: notification.infinite,
              closeButton: notification.closable ?? true,
              progressBar: true,
              onActivateTick: true,
              ...config,
            },
          );
        default:
          return notificationsSvc.info(
            notification.text ?? '',
            notification.title ?? '',
            {
              positionClass: position,
              timeOut: 7000,
              disableTimeOut: notification.infinite,
              closeButton: notification.closable ?? true,
              onActivateTick: true,
              ...config,
            },
          );
      }
    },
  };
}
